import { ContactForm } from '@/components/contact-form';
import SplitText from '@/components/split-text';
import { trackFooter, type TrackLocation } from '@/lib/analytics';

const BENEFITS = [
  'Kostenlose Erstberatung',
  '20+ Jahre Erfahrung',
  '100% maßgeschneidert',
  'Made in Hessen',
];

type ContactSectionProps = {
  /** Home animates the heading in on scroll; the standalone page is already at it. */
  animateHeading?: boolean;
  location: TrackLocation;
};

function CheckIcon() {
  return (
    <svg className="h-5 w-5 shrink-0 text-green-500" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function ContactSection({ animateHeading = true, location }: ContactSectionProps) {
  const heading = 'Bereit für den nächsten Schritt?';

  return (
    <section id="kontakt" className="w-screen scroll-mt-24 bg-zinc-950 py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl">
          <div className="text-center">
            <h2 className="mb-6 text-4xl font-bold text-white">
              {animateHeading ? (
                <SplitText
                  text={heading}
                  delay={25}
                  duration={0.6}
                  ease="power2.out"
                  splitType="words"
                />
              ) : (
                heading
              )}
            </h2>
            <p className="mb-12 text-xl leading-relaxed text-gray-400">
              Lassen Sie uns gemeinsam herausfinden, wie wir Ihr Unternehmen
              digitalisieren können. Kostenlose Beratung, maßgeschneiderte
              Lösungen.
            </p>
          </div>

          <div className="rounded-2xl border border-white/10 bg-zinc-900/60 p-6 shadow-sm backdrop-blur sm:p-10">
            <ContactForm location={location} />
          </div>

          <p className="mt-6 text-center text-sm text-gray-500">
            Lieber direkt?{' '}
            <a
              href="mailto:info@harmoniemedia.de"
              onClick={() => trackFooter('mailto-fallback')}
              className="text-purple-400 underline underline-offset-2 hover:text-purple-300"
            >
              info@harmoniemedia.de
            </a>
          </p>

          <div className="mt-16 rounded-2xl border border-white/10 bg-zinc-900/60 p-8 shadow-sm backdrop-blur">
            <h3 className="mb-4 text-xl font-semibold text-white">Warum Harmonie Media?</h3>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {BENEFITS.map((benefit) => (
                <div key={benefit} className="flex items-center gap-3">
                  <CheckIcon />
                  <span className="text-gray-300">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
